import { UserManager, WebStorageStateStore } from 'oidc-client-ts';


const oidcConfig = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  metadataUrl: import.meta.env.VITE_OIDC_AUTHORITY + 'o/.well-known/openid-configuration/',
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: window.location.origin + '/callback',
  response_type: 'code',
  scope: import.meta.env.VITE_OIDC_SCOPE,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
};
const userManager = new UserManager(oidcConfig);

export default userManager;
